module.exports = __webpack_public_path__ + "img/handle-charge.009c5676.svg";